import React, { Fragment } from "react";
import { connect } from "react-redux";
import moneyFormatter from "../../../common/moneyFormatter";
import "./details.scss";

const Details = props => {
  const {
    selectedPlan,
    savings,
    income,
    rate,
    AccumulationDetails,
    currentSavings,
    possibleAnnualSavings,
    annualIncomeNeeded,
    possibleAnnualIRA,
    retirementAccount,
    depletionFinalValue,
    acc_selectedPortfolio,
    activeGlidePath
  } = props;

  return (
    <div className="row details">
      {AccumulationDetails ? (
        <Fragment>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">
              {moneyFormatter(+currentSavings.toFixed(), false)}
            </span>
            <div>INITIAL SAVINGS</div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">
              {moneyFormatter(possibleAnnualSavings, false)}
            </span>
            <div>ANNUAL ADDITION</div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">
              {moneyFormatter(annualIncomeNeeded, false)}
            </span>
            <div>ANNUAL RETIREMENT INCOME NEEDED</div>
          </div>

          {/* <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">{socialSecurity.toFixed()}</span>
            <div>SOCIAL SECURITY</div>
          </div> */}

          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            {!activeGlidePath ? (
              <Fragment>
                <span className="detailValue">
                  {acc_selectedPortfolio.toFixed(2)}
                </span>
                <span>%</span>
                <div>GROWTH RATE</div>
              </Fragment>
            ) : (
              <Fragment>
                <span className="detailValue"> - </span>
                <div>GLIDE PATH</div>
              </Fragment>
            )}
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">
              {selectedPlan == "accumulation"
                ? // possibleAnnualIRA
                  retirementAccount == 0
                  ? retirementAccount
                  : moneyFormatter(retirementAccount, false)
                : retirementAccount == 0
                ? retirementAccount
                : moneyFormatter(retirementAccount, false)}
            </span>
            <div>IRA CONTRIBUTION</div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">
              {moneyFormatter(+savings.toFixed(), false)}
            </span>
            <div>RETIREMENT SAVINGS</div>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
            <span className="detailValue">
              {moneyFormatter(+savings.toFixed(), false)}
            </span>
            <div>RETIREMENT SAVINGS</div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">
              {moneyFormatter(income * 1000, false)}
            </span>
            <div>INCOME FROM SOCIAL SECURITY & OTHER SOURCES</div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">{rate.toFixed(2)}</span>
            <span>%</span>
            <div>GROWTH RATE</div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <span className="detailValue">
              {selectedPlan == "accumulation"
                ? retirementAccount == 0
                  ? retirementAccount
                  : moneyFormatter(retirementAccount, false)
                : retirementAccount == 0
                ? retirementAccount
                : moneyFormatter(retirementAccount, false)}
            </span>
            <div>IRA CONTRIBUTION</div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
            <span className="detailValue">
              {moneyFormatter(+depletionFinalValue.toFixed(), false)}
            </span>
            <div className="text-uppercase">
              Savings Remainder at the end of 20 years
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default connect(
  ({
    retirement: {
      rig: {
        intro: { selectedPlan },
        equation: {
          savings,
          income,
          withdraw,
          donut: { rate, excess },
          retirementAccount
        },
        accumulation: {
          currentSavings,
          possibleAnnualSavings,
          annualIncomeNeeded,
          socialSecurity,
          acc_otherIncome,
          possibleAnnualIRA,
          acc_selectedPortfolio,
          activeGlidePath
        }
      }
    }
  }) => ({
    selectedPlan,
    savings,
    income,
    withdraw,
    rate,
    excess,
    currentSavings,
    possibleAnnualSavings,
    annualIncomeNeeded,
    socialSecurity,
    acc_otherIncome,
    possibleAnnualIRA,
    retirementAccount,
    acc_selectedPortfolio,
    activeGlidePath
  }),
  null
)(Details);



// WEBPACK FOOTER //
// ./src/components/pages/Retire/solution/details.jsx